import { render, staticRenderFns } from "./white-labeling.vue?vue&type=template&id=23914e06&scoped=true&"
import script from "./white-labeling.ts?vue&type=script&lang=ts&"
export * from "./white-labeling.ts?vue&type=script&lang=ts&"
import style0 from "./white-labeling.scss?vue&type=style&index=0&id=23914e06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23914e06",
  null
  
)

export default component.exports